export default __webpack_public_path__ + "static/Activity-4x3-S_Walk-5aecc791543e6626f9dfb7f5e72bad32.png";